import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { SUPPORT_EMAIL, SUPPORT_EMAIL_CA } from "@utils/constants";
import { ReactComponent as UnknownIconIcon } from "@images/card-logo-unknown.svg";
import { ReactComponent as VisaIcon } from "@images/card-logo-visa.svg";
import { ReactComponent as MastercardIcon } from "@images/card-logo-mastercard.svg";
import { ReactComponent as AmexIcon } from "@images/card-logo-amex.svg";
import { ReactComponent as AffirmIcon } from "@images/affirm-logo.svg";
import { ReactComponent as PrintIcon } from "@images/print.svg";
import OrderSummary from "../order-summary";
import { OrderDetailProps } from "./PaymentHistory.model";
import {
  AccountHeader,
  AccountSection,
  RightAlignedContent,
  OrderHeader,
  OrderNumberWrap,
  OrderNumber,
  PrintButton,
  OrderDetails,
} from "../Account.styled";

const fetchCardIcon = (cc_type: string) => {
  switch (cc_type) {
    case "visa":
      return <VisaIcon />;
    case "master":
      return <MastercardIcon />;
    case "american_express":
      return <AmexIcon />;
    case "affirm":
      return <AffirmIcon />;
    default:
      return <UnknownIconIcon />;
  }
};

const OrderDetail = ({ order, membershipModal, toggleOrderDetails }: OrderDetailProps) => {
  if (!order) return null;

  const address = order.shippingAddress;
  const supportEmail = process.env.COUNTRY_CODE === "CA" ? SUPPORT_EMAIL_CA : SUPPORT_EMAIL;

  return (
    <AccountSection>
      <AccountHeader>
        <OrderHeader>
          <div className="grid-x grid-margin-x">
            <div className="cell medium-12 large-5">
              <button
                onClick={() => {
                  toggleOrderDetails(null);
                }}>
                Back to Payment History
              </button>
            </div>
            <RightAlignedContent className="cell medium-12 large-7">
              <h6>Questions about your order?</h6>
              <p>
                Email us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a>
              </p>
            </RightAlignedContent>
          </div>
        </OrderHeader>
        <OrderNumberWrap className="grid-x grid-margin-x">
          <div className="cell small-6">
            <OrderNumber>Order {order.orderNumber}</OrderNumber>
          </div>
          <div className="cell small-6 right">
            <PrintButton
              onClick={() => {
                window.print();
              }}>
              <PrintIcon />
              Print
            </PrintButton>
          </div>
        </OrderNumberWrap>
      </AccountHeader>
      <article className="grid-x grid-margin-x">
        <div className="cell medium-12 large-7">
          <OrderDetails>
            <dt>Order Number</dt>
            <dd>{order.orderNumber}</dd>
            <dt>Date</dt>
            <dd>{format(parseISO(order.processedAt), "MM/dd/yyyy")}</dd>
            {/* MIR-801: Order transaction data to be addressed by LLLS team after 3/1 launch.
            Need to update this code once we have that information */}
            {/* <dt>Payment Method</dt>
            {order.payments.map((p) => {
              return p.source_type === "affirm" ? (
                <PaymentMethod key={p.id} className="affirm">
                  &nbsp;
                </PaymentMethod>
              ) : (
                <PaymentMethod key={p.id}>
                  <span className="credit-card">{fetchCardIcon(p.source.cc_type)}</span>
                  **** {p.source.last_digits}
                </PaymentMethod>
              );
            })} */}
          </OrderDetails>
        </div>
        {address && (
          <RightAlignedContent className="cell medium-12 large-5">
            <h6>Shipping Address</h6>
            <address>
              {address.firstName} {address.lastName}
              <br />
              {address.address1}
              {address.address2 && [<br key={0} />, address.address2]}
              <br />
              {address.city}, {address.provinceCode} {address.zip}
            </address>
          </RightAlignedContent>
        )}
        <div className="cell small-12">
          <OrderSummary order={order} membershipModal={membershipModal} />
        </div>
      </article>
    </AccountSection>
  );
};

export default OrderDetail;
